import { AT_BOARDS_REQUESTS_STATE_SET, IBoardsRequestsStateSetAction } from './types';
import { IBoardsRequestsState } from '../reducers/types';

export const boardsRequestsStateSetAction = (
    boards: IBoardsRequestsState
): IBoardsRequestsStateSetAction => ({
    type: AT_BOARDS_REQUESTS_STATE_SET,
    boards
});
